import React from 'react';
export function Footer() {
  return <footer className="border-t border-dark-border py-9 px-[5%] flex justify-between items-center relative z-10 flex-wrap gap-4" data-id="element-20">
      <div className="font-bebas text-[1.2rem] tracking-[3px] text-text-muted" data-id="element-21">
        GANSTER STYLE
      </div>
      <div className="text-[0.75rem] text-text-muted" data-id="element-22">
        © 2025 Ganster Style · Venado Tuerto, Santa Fe, Argentina
      </div>
      <div data-id="element-23">
        <a href="https://www.instagram.com/gansterstylee" target="_blank" rel="noreferrer" className="text-text-muted no-underline text-[0.75rem] tracking-[1px] transition-colors duration-300 hover:text-neon-pink" data-id="element-24">
          → @gansterstylee
        </a>
      </div>
    </footer>;
}